import { withStyles } from '@material-ui/core';
import { Marker } from '../../../../../lib/Map';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import GeoFenceEntryExitIcon from '../StopDetails/GeoFenceEntryExitIcon';
import { getTimeString } from '../Utils';
import LogoutIcon from '../../../Dispatch/RouteExecution/utils/DriverStatus/Icons/LogoutIcon';
import EnterTerminalIcon from '../../../Dispatch/RouteExecution/utils/DriverStatus/Icons/EnterTerminalIcon';

const styles = (theme) => ({
  time: {
    paddingLeft: 6
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: -66
  },
  singleMarkerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: -30
  },
  tooltipLabel: {
    backgroundColor: theme.tooltipBGColor,
    color: theme.iconColor,
    padding: '4px 8px',
    borderRadius: 4,
    letterSpacing: 0.5,
    display: 'flex',
    alignItems: 'center'
  },
  entryArrow: {
    fontSize: 49,
    margin: '-28 0 -18',
    color: theme.tooltipBGColor
  },
  exitArrow: {
    fontSize: 49,
    margin: '-21 0 -18',
    color: theme.tooltipBGColor
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 2
  }
});

const GeofenceMarkerLabel = ({ classes, theme, geofenceData, IconComponent, isEntry }) => {
  if (!geofenceData?.time) return null;
  
  return (
    <div className={classes.labelContainer}>
      <span className={classes.tooltipLabel}>
        <IconComponent color={theme.iconColor} />
        <span className={classes.time}>{getTimeString(geofenceData.time)}</span>
      </span>
      <ArrowDropDownIcon className={isEntry ? classes.entryArrow : classes.exitArrow} />
    </div>
  );
};

const TerminalGeofenceEntryExitMarker = ({ classes, theme, key, entry, exit }) => {
  const isBothEntryExitTimePresent = entry?.time && exit?.time;
  if ((entry?.lat && entry?.lng && entry?.time) || (exit?.lat && exit?.lng && exit?.time)) {
    return (
      <Marker
        position={{ lat: entry.lat || exit.lat, lng: entry.lng || exit.lng }}
        key={`${key}_terminal`}
        zIndex={1}
        onClick={null}>
        <div
          className={
            isBothEntryExitTimePresent ? classes.container : classes.singleMarkerContainer
          }>
          <GeofenceMarkerLabel   
            classes={classes}
            theme={theme}
            geofenceData={entry}
            IconComponent={EnterTerminalIcon}
            isEntry={true}
          />
          
          <GeofenceMarkerLabel 
            classes={classes}
            theme={theme}
            geofenceData={exit}
            IconComponent={LogoutIcon}
            isEntry={false}
          />
          <GeoFenceEntryExitIcon />
        </div>
      </Marker>
    );
  }
  return null;
};

export default withStyles(styles)(TerminalGeofenceEntryExitMarker);
